const initialState = { products: [], product: null, relatedProducts: [], reviews: [], addresses: [] };
export default function product(state = initialState) {
  return state;
}
